import { ActivityTemplateCode } from './activity-template.model';

export const ActivityTypePermissions = {
  [ActivityTemplateCode.Other]: 'isHubActivityFormEnabled'
};
